// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"63":"brandChannelV2","883":"brandChannel"}[chunkId] + "." + {"63":"a08b2bd4","883":"52743acb"}[chunkId] + ".css";
};